import React from 'react';
import TextButton from '@wix/da-ds/pkg/Buttons/TextButton';
import ArrowDown from '@wix/da-ds/pkg/Icons/ArrowDown';
import ArrowUp from '@wix/da-ds/pkg/Icons/ArrowUp';

import s from './SelectToggle.scss';

export interface Props {
  /** Determines the label shown against the toggle */
  label: string;

  /** Determines what text we show in the toggle */
  value: string;

  /** Determines the way the postfixed arrow is pointing (down for `false`, up for `true`) */
  isToggled?: boolean;

  /** What happens when you click on the toggle */
  onClick?: () => void;
}

const SelectToggle: React.FC<Props> = ({ label, value, isToggled, onClick }) => {
  return (
    <div className={s['root']}>
      <span className={s['label']}>{label}</span>
      <TextButton
        onClick={onClick}
        size="small"
        variant="main"
        className={s['button']}
        postfix={isToggled ? ArrowUp : ArrowDown}
      >
        {value}
      </TextButton>
    </div>
  );
};
SelectToggle.displayName = 'SelectToggle';

export default SelectToggle;
